import { ISimpleType, ModelInstanceTypeProps, types } from 'mobx-state-tree';

export interface CustomError {
	code?: string;
	message?: string;
	status: number;
}

export const CustomErrorModel = types.model({
	code: types.string,
	message: types.string,
	status: types.number,
});

export interface Params {
	[key: string]: string | number | boolean | Array<string | number | boolean>;
}

export interface AxiosParams<T extends Params = any> {
	path: string;
	params?: T;
	isApi?: boolean;
	headers?: { [key: string]: string };
	method?: 'get' | 'post' | 'put' | 'patch';
	abortWithParams?: boolean;
}

export type MSTCustomError = ModelInstanceTypeProps<{
	code: ISimpleType<string>;
	message: ISimpleType<string>;
	status: ISimpleType<number>;
}>;
